export default __webpack_public_path__ + "locales/ko-KR/Webhooks.json?hash=795f896186bdc0e5a0dc8c0883714b43";